angular.module('impactx.address').directive('appAddressInput', [function() {
    return {
        scope: {
            addresses: '=',
            labelTitle: '=',
            hideLabel: '=?',
            addressType: '@',
            selectionId: '=',
            selected: '=',
            trns: '=',
            enableNew: '=',
            enableEdit: '=',
            availTypes: '=',
            showInheritanceOptions: '=',
            onChange: '=',
            owningComOptions: '=',
            disableOwningCom: '=',
            saveDirect: '=',
            autofocus: '=',
            disableInput: '=',
            entryPoint: "@",
            personalData: "=",
            additionalDataForEntryPoint: "=",
            regionCode: "="
        },
        controller: 'AddressInputCtrl',
        controllerAs: 'ctrl',
        restrict: 'E',
        templateUrl: 'modules/address/templates/address-input.tmpl.html'
    };
}
]);